// DOPASUJ nagłówki (Authorization itd.) do tego, jak masz w useCreateEvent
import { useContext } from "react";
import { AuthContext } from "../auth/AuthContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export function useDeleteEvent() {
    const { accessToken } = useContext(AuthContext);

  const deleteEvent = async (id) => {
    try {
      const res = await fetch(`${API_BASE}/api/events/${id}/`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (res.status === 204) {
        return { success: true };
      }

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        return {
          success: false,
          message: data.detail || "Błąd usuwania wydarzenia",
        };
      }

      // czasem DRF zwraca 200 + body, ale najczęściej 204
      return { success: true };
    } catch (err) {
      console.error(err);
      return {
        success: false,
        message: "Wystąpił błąd sieci podczas usuwania wydarzenia",
      };
    }
  };

  return { deleteEvent };
}
